import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";
// PlantVarietyRegistration.jsx

const PlantVarietyRegistration = () => {
  
 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  return (
    <div className="service-page">

    <Helmet>
        <title>
          Plant Variety Registration Service | PVPFR Registration India
        </title>

        <meta
          name="description"
          content="Protect new plant varieties, seeds, and crops with Plant Variety Protection (PVPFR) Registration in India. Secure breeder rights legally."
        />

        <meta
          name="keywords"
          content="Plant Variety Registration, PVPFR Registration, Seed Registration India, Crop Variety Protection, Plant Breeder Rights"
        />
      </Helmet>
 
      {/* HERO */}
      <section className="service-hero">
        <h1>Plant Variety Protection (PVPFR) Registration</h1>

        <p>
          Protect New Plant Varieties, Seeds & Agricultural Innovations
        </p>
         <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>

        <div className="card">
          <p>
            Plant Variety Protection under the Protection of Plant Varieties and
            Farmers’ Rights Act (PVPFR) provides legal rights to breeders,
            researchers, and farmers for developing new plant varieties.
          </p>

          <p>
            Registration helps protect unique crops, seeds, hybrids, and plant
            varieties from unauthorized production, sale, or distribution.
          </p>
        </div>
      </section>

      {/* WHAT IT PROTECTS */}
      <section className="service-section">
        <h2>What Does PVPFR Protect?</h2>

        <div className="service-grid-box">

          <div className="card">
            New Plant Varieties
          </div>

          <div className="card">
            Seeds & Hybrids
          </div>

          <div className="card">
            Agricultural Crops
          </div>

          <div className="card">
            Horticulture Varieties
          </div>

          <div className="card">
            Trees & Vines
          </div>

          <div className="card">
            Genetically Improved Plants
          </div>

        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Plant Variety Registration</h2>

        <div className="service-grid-box">

          <div className="card">
            ✔ Exclusive breeder rights
          </div>

          <div className="card">
            ✔ Legal protection for new varieties
          </div>

          <div className="card">
            ✔ Prevents unauthorized selling
          </div>

          <div className="card">
            ✔ Enhances commercial value
          </div>

          <div className="card">
            ✔ Encourages agricultural innovation
          </div>

          <div className="card">
            ✔ Recognition for plant breeders
          </div>

        </div>
      </section>

      {/* VALIDITY */}
      <section className="service-section">
        <h2>Validity of Registration</h2>

        <div className="service-grid-box">

          <div className="card">
            15 Years – Crops & Seeds
          </div>

          <div className="card">
            18 Years – Trees & Vines
          </div>

        </div>
      </section>

      {/* WHO SHOULD APPLY */}
      <section className="service-section">
        <h2>Who Should Apply?</h2>

        <div className="service-grid-box">

          <div className="card">
            Plant Breeders
          </div>

          <div className="card">
            Agricultural Researchers
          </div>

          <div className="card">
            Seed Companies
          </div>

          <div className="card">
            Farmers
          </div>

          <div className="card">
            Agricultural Startups
          </div>

          <div className="card">
            Research Institutions
          </div>

        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>

        <div className="service-grid-box">

          <div className="card">
            Applicant ID & Address Proof
          </div>

          <div className="card">
            Plant Variety Details
          </div>

          <div className="card">
            Origin & Breeding Information
          </div>

          <div className="card">
            Seed Sample / Technical Data
          </div>

          <div className="card">
            Authorization Documents
          </div>

          <div className="card">
            Business / Institution Proof
          </div>

        </div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>Plant Variety Registration Process</h2>

        <div className="service-grid-box">

          <div className="card">
            Eligibility Assessment
          </div>

          <div className="card">
            Documentation Preparation
          </div>

          <div className="card">
            Application Filing
          </div>

          <div className="card">
            Technical Examination
          </div>

          <div className="card">
            DUS Testing (if required)
          </div>

          <div className="card">
            Registration Certificate Issuance
          </div>

        </div>
      </section>

      {/* OUR SERVICES */}
      <section className="service-section">
        <h2>Our PVPFR Services Include</h2>

        <div className="card">
          <ul>
            <li>Plant variety eligibility analysis</li>
            <li>Preparation of registration application</li>
            <li>Documentation & technical guidance</li>
            <li>Application filing support</li>
            <li>Compliance & objection assistance</li>
            <li>End-to-end registration support</li>
          </ul>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="card">
          <ul>
            <li>✔ Expertise in agricultural IPR services</li>
            <li>✔ Complete documentation support</li>
            <li>✔ Affordable professional assistance</li>
            <li>✔ Smooth registration process</li>
            <li>✔ End-to-end compliance guidance</li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Protect Your Agricultural Innovation</h2>

        <p>
          Secure legal rights for your new plant varieties and seeds with
          professional PVPFR registration assistance.
        </p>

        <button>Apply for Plant Variety Registration</button>
      </section> */}

         <div className="cta" ref={contactRef}>
        <h2>Protect Your Agricultural Innovation</h2>

               <p>
          Secure legal rights for your new plant varieties and seeds with
          professional PVPFR registration assistance.
        </p>

              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Apply for Plant Variety Registration</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default PlantVarietyRegistration;